import Heading from "../../heading"
import ContactUs from "./contactUs"
import { PropTypes } from 'prop-types';

const PopUp = ({ title,heading, description, img,  cards, socialIcons, contacts }) => {
    return (
        <div className="flex flex-col gap-5 w-full  p-4 max-h-[80vh] max-w-[80vw] overflow-y-auto scroll-bar">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 w-full  ">
                <div className="flex flex-col gap-5">
                    <div className="flex flex-col gap-3">
                        <Heading name={heading} color="text-blue-500" />
                    </div>
                    <p className="text-sky-950 w-auto whitespace-pre-line text-opacity-70 text-base font-normal leading-normal">{description}</p>
                    {/* <h1 className="text-slate-900 text-4xl font-bold leading-snug ">How Can We Help?</h1>
                    <div className="flex flex-col gap-10">
                        {
                            points.map((point, index) => (
                                <div className="flex flex-col" key={index}>
                                    <h2 className="w-auto  text-slate-900 text-2xl font-bold leading-loose">{point.title}</h2>
                                    <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal  leading-relaxed">{point.paragraph}</p>
                                </div>
                            ))
                        }
                    </div> */}
                </div>
                <div className="flex flex-col gap-10">
                    <div className="w-full h-[30rem] bg-center bg-cover bg-no-repeat" style={{ backgroundImage: `url('${img}')` }}>
                    </div>
                    <div className="flex flex-col gap-8">
                        {
                            cards?.map((card, index) => (
                                <div className="flex flex-col gap-3" key={index}>
                                    <div className="flex flex-col gap-5 items-center">
                                        {card.icon}
                                        <h2 className="w-auto  text-slate-900 text-2xl font-bold leading-loose">{card.title}</h2>
                                    </div>
                                    <p className="w-auto text-center text-sky-950 text-opacity-70 text-base font-normal  leading-relaxed">{card.content}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

            </div>
            <ContactUs title={title} socialIcons={socialIcons} contacts={contacts} />
        </div>
    )
}
PopUp.propTypes = {
    title: PropTypes.string,
    heading: PropTypes.string,
    img: PropTypes.string,
    description: PropTypes.any,
    cards: PropTypes.any,
    socialIcons: PropTypes.array,
    contacts: PropTypes.any
}
export default PopUp